import React from 'react'
import { BackTop, Layout, Spin, Button } from 'antd'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
// import TopBar from 'components/LayoutComponents/TopBar'
import Menu from 'components/LayoutComponents/Menu'
// import Footer from 'components/LayoutComponents/Footer'
// import Breadcrumbs from 'components/LayoutComponents/Breadcrumbs'
// import Settings from 'components/LayoutComponents/Settings'
import CommonService from '../../services/commonService'
import urlConstant from '../../constants/urlConstant'

const mapStateToProps = ({ settings, customSpinner, user }) => ({
  isBorderless: settings.isBorderless,
  isSquaredBorders: settings.isSquaredBorders,
  isFixedWidth: settings.isFixedWidth,
  isMenuShadow: settings.isMenuShadow,
  isMenuTop: settings.isMenuTop,
  apiloading: customSpinner.apiloading,
  IsImpersonate: user.IsImpersonate,
  email: user.email,
  name: user.name,
  TenantGuid: user.TenantGuid
})

@withRouter
@connect(mapStateToProps)
class MainLayout extends React.PureComponent {
  constructor(props) {
    super(props);
    this.CommonService = new CommonService();
  }

  userImpersonateLogout = () => {
    const { TenantGuid } = this.props
    const userData = JSON.parse(localStorage.getItem('webappuser'))
    localStorage.clear()
    window.location.href = `${urlConstant.Impersonate.UserImpersonateLogout}?q=${TenantGuid}&impersonatingUserId=${userData.ImpersonateUserID}&ImpersonatorClientId=${userData.ImpersonatorClientId}`
  }

  render() {
    const {
      children,
      isBorderless,
      isSquaredBorders,
      isFixedWidth,
      isMenuShadow,
      isMenuTop,
      apiloading,
      IsImpersonate,
      email,
      name
    } = this.props
    return (
      <Layout
        className={classNames({
          settings__borderLess: isBorderless,
          settings__squaredBorders: isSquaredBorders,
          settings__fixedWidth: isFixedWidth,
          settings__menuShadow: isMenuShadow,
          settings__menuTop: isMenuTop,
        })}
      >
        <BackTop />
        <Spin spinning={apiloading} tip="Loading...">
          <Menu />
          {/* <Settings /> */}
          <Layout>
            {/* <Layout.Header>
              <TopBar />
            </Layout.Header> */}
            <Layout.Content style={{ height: '100%', position: 'relative' }}>
              {/* <Breadcrumbs /> */}
              {IsImpersonate === "true" &&
                <div className="cm-impersonate-div d-flex justify-content-center align-items-center">
                  <h5 className="cm-impersonate-text">You are impersonating {name} ({email})</h5>&nbsp;<Button className='ml-3 font-size-12' key="Cancel" type="primary" onClick={this.userImpersonateLogout}>Exit</Button>
                </div>
              }
              <div className="utils__content">{children}</div>
            </Layout.Content>
            {/* <Layout.Footer>
              <Footer />
            </Layout.Footer> */}
          </Layout>
        </Spin>
      </Layout>
    )
  }
}

export default MainLayout
